"use client";
'use strict';

var React = require('react');
var useCallbackRef = require('./useCallbackRef.js');

/**
 * React Hook that provides a declarative `setInterval`
 *
 * @param callback the callback to execute at interval
 * @param delay the `setInterval` delay (in ms)
 */
function useInterval(callback, delay) {
    const fn = useCallbackRef.useCallbackRef(callback);
    React.useEffect(() => {
        let intervalId = null;
        const tick = () => fn();
        if (delay !== null) {
            intervalId = window.setInterval(tick, delay);
        }
        return () => {
            if (intervalId) {
                window.clearInterval(intervalId);
            }
        };
    }, [delay, fn]);
}

exports.useInterval = useInterval;
//# sourceMappingURL=useInterval.js.map
